import { render, staticRenderFns } from "./SellerList.vue?vue&type=template&id=b3bfd54e&"
import script from "./SellerList.vue?vue&type=script&lang=ts&"
export * from "./SellerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports